import type { ClassData, Field, Method, TypeDef } from '@/core/types/library.type'

import { getUnifiedGraftModelType } from '../getUnifiedGraftModelType'
import { getUniqueKey } from '../getUniqueKey'

import { GLOBAL_ENTRY_KIND } from './const/globalEntryKind.const'
import { GLOBAL_ENTRY_SUFFIX } from './const/globalEntrySuffix.const'
import { mapClass } from './mapClass'
import { mapField } from './mapField'
import { mapMethod } from './mapMethod'

export const mapGlobalLibraryEntries = (members: unknown[]): Array<[string, ClassData]> => {
  const getKind = (member: unknown) =>
    getUnifiedGraftModelType(member as { unifiedGraftModelType?: unknown; graftModelType?: unknown })

  const methodEntries = members
    .filter((member) => GLOBAL_ENTRY_KIND.METHOD.has(getKind(member)))
    .map((member, index): [string, ClassData] => {
      const method = mapMethod(member as Method)

      return [
        `${method.name}-${index}-${GLOBAL_ENTRY_SUFFIX.METHOD}`,
        {
          namespace: '',
          name: method.name,
          methods: { [getUniqueKey(method, index)]: method },
        },
      ]
    })

  const fieldEntries = members
    .filter((member) => GLOBAL_ENTRY_KIND.FIELD.has(getKind(member)))
    .map((member, index): [string, ClassData] => {
      const field = mapField(member as Field)

      return [
        `${field.name}-${index}-${GLOBAL_ENTRY_SUFFIX.FIELD}`,
        {
          namespace: '',
          name: field.name,
          fields: { [field.name]: field },
        },
      ]
    })

  const typeEntries = members
    .filter((member) => GLOBAL_ENTRY_KIND.TYPE.has(getKind(member)))
    .map((member, index): [string, ClassData] => {
      const typeDef = mapClass(member as TypeDef)

      return [`${typeDef.name}-${index}-${GLOBAL_ENTRY_SUFFIX.TYPE}`, typeDef]
    })

  return [...methodEntries, ...fieldEntries, ...typeEntries]
}
